import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { DataRowComponent } from "../../_component/pagination-client-side/data-row.component";
import { Utils } from "../../../_helpers/utils";
import { EditBookingComponent } from "../edit-booking/edit-booking.component";
import { BookingService } from "../../../_services/booking.service";
import { ModalController } from "@ionic/angular";
import { ImagePreviewComponent } from "src/app/app/_component/image-preview/image-preview.component";
import { BookingModel, BookingStatus } from "src/app/_models/booking.model";
import { DictionaryService } from "src/app/dictionary";
import { TranslateService } from "@ngx-translate/core";
import { SpaceType } from "src/app/_types/space-type";

@Component({
  selector: "app-booking-view",
  templateUrl: "./booking-view.component.html",
  styleUrls: [
    "./booking-view.component.scss",
    "./../../../_styles/ion-grid-content-table.scss",
  ],
})
export class BookingViewComponent implements OnInit, DataRowComponent {
  constructor(
    public bookingServ: BookingService,
    private modalCtrl: ModalController,
    public dictionaryServ: DictionaryService,
    public translateServ: TranslateService
  ) {}

  @Input()
  row: any;

  @Input()
  displayMobileView = false;

  @Input()
  styleClass;

  @Input()
  dateKeySeparator: string;

  @Output()
  refreshRequest: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  actionRequest: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {}

  delete($event) {
    $event.preventDefault();
    $event.stopPropagation();

    this.actionRequest.emit({
      type: "remove",
      id: this.row.id,
    });
  }

  onClickBooking(booking) {
    this.bookingServ.getBooking(booking.id).subscribe(
      (booking: BookingModel) => {
        this.bookingServ.booking = booking;
        this.openDialog(EditBookingComponent);
      });
  }

  // Otwiera okienka dialogowe, przyjmuje komponent(jego nazwę) za argument
  async openDialog(DialogName: any) {
    const bookingSpace = this.bookingServ?.booking?.bookingSpaces[0] ?? null;
    const modal = await this.modalCtrl.create({
      component: DialogName,
      animated: true,
      cssClass: "add-edit-modal",
      componentProps: {
        type: SpaceType.Room,
        roomTimeFrom: bookingSpace?.space?.timeFrom ?? null, 
        roomTimeTo:bookingSpace?.space?.timeTo ?? null
      }
    });
    modal.dismiss(() => {
      // this.subscribeEvents();
    });
    modal.present();
  }

  public sameDay(d1, d2) {
    return Utils.sameDay(new Date(d1), new Date(d2));
  }

  async onImagePreview($event, url) {
    $event.stopPropagation();
    $event.preventDefault();

    const modal = await this.modalCtrl.create({
      component: ImagePreviewComponent,
      componentProps: { src: url },
      animated: true,
      cssClass: "image-preview-present",
    });
    modal.present();
  }
}
